import { VueExtension } from '../../utils/extensions/vue';
import Cell from './cell.jsx';
import './cell.scss';

VueExtension.WithInstall(Cell);

export default Cell;
